import React from 'react'
import styled from 'styled-components'
import { WithAuth as Root } from '@/components/Root'
import { CouponsTable } from '@/components/tables/CouponsTable'
import { Layout, PageHeader } from 'antd'

const pageTitle = 'クーポン'

export default () => (
  <Root title={pageTitle}>
    <Layout>
      <StyledPageHeader title={pageTitle} />
      <CouponsTable />
    </Layout>
  </Root>
)

const StyledPageHeader = styled(PageHeader)`
  margin: 16px 0;
  background-color: #fff;
`
